import actionTypes from './actionTypes';
import config from '../../../config/config';
import { getresponse } from '../../Login/actions'
const {
  REQUEST_SIGNUP,
  RECEIVE_SIGNUP_STATUS,
  ERROR_OCURED,
  AUTH_ERRORS
} = actionTypes;

function requestSignup() {
  return {
    type: REQUEST_SIGNUP
  };
}

function hasErrored(bool) {
  return {
    type: ERROR_OCURED,
    hasErrored: bool
  };
}

export function recieveSignupstatus(bool, user) {
  return {
    type: RECEIVE_SIGNUP_STATUS,
    success: bool,
    user
  };
}

export function authErrors(errors) {
  return {
    type: AUTH_ERRORS,
    errors
  };
}

export function signupUser(email, password, name, plan, domain_url,fvlite_role,phone_number,company_name) {
  return function(dispatch) {
    dispatch(requestSignup());
    const payload = {
      email,
      password,
      name,
      plan,
      domain_url,
      service_name: "fvlite",
      fvlite_role,
      phone_number,
      company_name
    };
    let myHeaders = new Headers();
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8');
    return fetch(`${config.URI}/api/v1/signup`, {
      method: 'post',
      headers: myHeaders,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText);
        } else {
          return res.json();
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          getresponse(res, res.data.user.email, res.data.user.password,'', dispatch)
        } else if (res.errors) {
              alert(res.errors);    
          dispatch(authErrors(res.errors));
          console.error(res.errors)
        }
      })
      .catch((error) => {
          dispatch(hasErrored(true))
          
          console.error(error)
        }
      );
  };
}


// WEBPACK FOOTER //
// src/routes/SignUp/actions/index.js